enum ActivityCompanyOption {
  ALL = "all",
  HAS_COMPANY = "hasCompany",
  NO_COMPANY = "noCompany",
}

export default ActivityCompanyOption;
